// extracted by mini-css-extract-plugin
export default {"wrapper":"LevelTileIcon_wrapper__U0QeK","icon":"LevelTileIcon_icon__3zv9g","notActive":"LevelTileIcon_notActive__D5Bew"};